import React from 'react';

import Heading from '@atlaskit/heading/heading';

import SuccessContainer from './SuccessContainer';

export default (): React.JSX.Element => (
	<SuccessContainer>
		<Heading size="xsmall">Thanks for your feedback</Heading>
	</SuccessContainer>
);
